import { LandingPageTemplateService } from '@weave/schema-gen-ts/dist/schemas/reviews/landing-page-templates/v1/landing_page_template_service.pb';
import { bindHTTP } from '@frontend/schema';

export const SchemaLandingPageTemplateV1Service = bindHTTP(LandingPageTemplateService);
